import { apiFetch } from './apiFetch';

const API_BASE = process.env.REACT_APP_API_URL;

export async function fetchPlans() {
  const res = await apiFetch(`${API_BASE}/admin/plan`);
  return res.json();
}

export async function fetchPlan(planId) {
  const res = await apiFetch(`${API_BASE}/admin/plan/${planId}`);
  return res.json();
}

export async function createPlan(planData) {
  const res = await apiFetch(`${API_BASE}/admin/plan`, {
    method: 'POST',
    body: JSON.stringify(planData)
  });
  return res.json();
}

export async function updatePlan(planId, planData) {
  const res = await apiFetch(`${API_BASE}/admin/plan/${planId}`, {
    method: 'PUT',
    body: JSON.stringify(planData)
  });
  return res.json();
}
